import React, { useRef, useState } from "react";
import {
  Navbar,
  Nav,
  OverlayTrigger,
  Tooltip,
  Popover,
  Container,
  Row,
  Col,
  Button,
  Form,
  Overlay,
  Modal
} from "react-bootstrap";
import styles from "../mainbar.module.css";
import { lddGlobalSessionInfo, NavObjectType } from "../navigationTypes";
import {
  TopBarConfig,
  framesChangeClass,
  isDarkTheme,
  setCookie,
} from "./topBarFuncs";
import ReportForm from "../Forms/ReportForm";
import SuggestionForm from "../Forms/SuggestionForm";
import { activityCenterObject } from "../../fileToolbar/ActivityCenter/activityCenterTypes";
import { formatAMPMString } from "../../fileToolbar/fileToolbarFuncs";
import { displayToastMsg } from "../toastMessages/toastmessages";
import { isPageInDR } from "../../dr/Components/drFuncs";
import { Avatar } from "../../Components/ui/avatar/avatar";

/*
const GetAccountName = (sessionInfo: lddGlobalSessionInfo) => {
    if (sessionInfo === undefined) {
        return <>loading...</>;
    }
    return sessionInfo.firm.account;
}*/

const GetFullName = (sessionInfo: lddGlobalSessionInfo) => {
  if (sessionInfo === undefined) {
    return <>loading...</>;
  }
  return sessionInfo.user.fullname;
};

const GetInitials = (sessionInfo: lddGlobalSessionInfo) => {
  if (sessionInfo === undefined) {
    return <i className="fa-regular fa-user"></i>
  }
  return sessionInfo.user.initials;
}

export function launchLDDnxt(
  url: string,
  sid: string,
  SessionInfo: lddGlobalSessionInfo
) {
  if (url.indexOf("book-training-rw") !== -1) {
    url += "#book-training-rw" + process.env.REACT_APP_APPCODE.toLowerCase();
  }
  url = `${url}?first_name=${SessionInfo.user.firstname || ''}&last_name=${SessionInfo.user.lastname || ''}&email=${SessionInfo.user.email || ''}&a1=${SessionInfo.firm.name || ''}&phone=${SessionInfo.user.phone || ''}&acc_name=${SessionInfo.firm.account || ''}&acc_id=${SessionInfo.firm.id || ''}&province=${SessionInfo.appProvinceShort || ''}`;
  window.open(url, "_blank");
}

function toggleDarkTheme(e) {
  var checked = e.target.checked;
  var val = checked ? 1 : 0;
  setCookie("darkMode", val, 365);
  framesChangeClass("dark", checked);
}

/**
 * This is a base layer of TopBar, applies to RPW, docservice and dr, with items configured in topBarConfig
 * Any components inside here should be generic to all.
 * More specified items should be implemented in its parent.
 */
const BaseTopBar = (props: {topBarConfig: TopBarConfig, actions: any, sessionInfo: lddGlobalSessionInfo, sid: string, page?: NavObjectType, isEsignTopbar?: boolean}) => {
    const sessionInfo: lddGlobalSessionInfo = props.sessionInfo;
    const sid: string = props.sid;
    const isCollege: boolean = sessionInfo?.firm?.IsCollege;
    const [showHelp, setShowHelp] = useState(false);
    const [targetHelp, setTargetHelp] = useState(null);
    const [showAccount, setShowAccount] = useState(false);
    const [targetAccount, setTargetAccount] = useState(null);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [showSuggestionBox, setShowSuggestionBox] = useState(false);
    const profileRef = useRef(null);
    const refAccount = useRef(null);
    const page = props.page;

    function handleAccountClick (event:Event) {
        setShowAccount(!showAccount);
        setTargetAccount(event.target);
    }
    
    const baseActions = {
        "handleHelpClick": (event:Event) => {
            setShowHelp(!showHelp);
            setTargetHelp(event.target);
        },
        "toggleDarkTheme": (e:Event) => {
            toggleDarkTheme(e);
        },
        "logout": () => {
            sessionStorage.clear();
            window.location.href = `/lddlogout.asp?SessionID=${sid}`;
        },
        "isDarkTheme": () => {
            return isDarkTheme();
        }
    };

  const actions = { ...baseActions, ...props.actions };

  let appcode = "LITE";
  switch (sessionInfo?.appCode) {
    case "RPW":
      appcode = "ON";
      break;
    case "RPWAB":
      appcode = "AB";
      break;
    case "RPWSK":
      appcode = "SK";
      break;
    case "RPWMB":
      appcode = "MB";
      break;
    case "RPWNS":
      appcode = "NS";
      break;
    case "RPWBC":
      appcode = "BC";
      break;
    case "DR":
      appcode = "LITE";
      break;
    case "WILL":
      appcode = "WILL";
      break;  
  }
  if (isCollege) {
    appcode = "CLG";
  }

  const handleErrorClick = () => {
    setShowHelp(false);
    setShowErrorModal(true);
  };

  const handleSuggestionClick = () => {
    setShowHelp(false);
    setShowSuggestionBox(true);
  };

    function formSubmitSuccessAlert(success: boolean) {
        let currentDate = new Date();
        let dateStr = currentDate.toDateString().split(" ");
        let timeStr = currentDate.toTimeString();
        timeStr = formatAMPMString(timeStr);
        const newMessage: activityCenterObject = {
            index: undefined,
            message: success ? <p><b>Submission received!</b> Thank you. We will get back to you shortly.</p> : <p>There was a problem submitting your request, please try again or contact Support directly</p>,
            type: success ? "success" : "error",
            dateCreated: timeStr + ' ' + dateStr[1] + ' ' + dateStr[2] + ' ',
            clearWhenOut: true,
        };
        displayToastMsg({ id: null, msg: newMessage.message as JSX.Element, type: newMessage.type }, null);
    }

  return (
    <Navbar className={"navGlobal " + styles.navGlobal}> 
        <Col>
            <OverlayTrigger
                placement="bottom"
                delay={300}
                overlay={<Tooltip>Home</Tooltip>}
            >
                <span className={styles.logo}>
                    <img
                        src={process.env.PUBLIC_URL + "/" + props.topBarConfig.home.logo}
                        alt={props.topBarConfig.home.alt}
                        onClick={actions["OpenMainPage"]}
                    />
                </span>
            </OverlayTrigger>
        </Col>

        
        <Col style={{ textAlign: 'center' }}>
            {props.topBarConfig.home.middleText ? (
                <Navbar.Brand className={styles.appLogo} style={{ color: 'white', fontWeight: 'bold' }}>
                    {props.topBarConfig.home.middleText}
                </Navbar.Brand>
            ) : props.topBarConfig.home.middleIcon && (
                <Navbar.Brand className={styles.appLogo}>
                    <img
                        src={process.env.PUBLIC_URL + "/" + props.topBarConfig.home.middleIcon}
                        alt={props.topBarConfig.home.alt}
                        onClick={actions["OpenMainPage"]}
                    />
                    {props.topBarConfig.home.showAppCode && (
                        <p className={styles.province}>{appcode}</p>
                    )}
                </Navbar.Brand>
            )}
        </Col>

        <Col>
            <div className="dialog-title" />
            
            <Navbar.Toggle />

            <Navbar.Collapse style={{ flexGrow: 'initial', gap: '16px', justifyContent: 'flex-end' }}>
                {props.topBarConfig.items.map((item, index) => {
                    // Skip rendering if item requires session but sessionInfo is empty
                    if (item.requireSession && !sessionInfo) return null;
                    if (item.requiredField) {
                        const checkedVal = actions[item.requiredField.field]();
                    if (
                    !checkedVal ||
                    (item.requiredField.value &&
                        item.requiredField.value !== checkedVal)
                    ) {
                    return null;
                    }
                }
                if (item.placeholder) {
                    return actions[item.action](index);
                }
                return (
                    <Nav.Item className={styles.item} key={`nav-item-${index}`}>
                        <OverlayTrigger
                            placement="bottom"
                            delay={300}
                            overlay={<Tooltip>{item.tooltip}</Tooltip>}
                        >
                            <Nav.Link
                            onClick={(event) =>
                                actions[item.action] &&
                                typeof actions[item.action] === "function" &&
                                actions[item.action](event)
                            }
                            >
                            <i className={item.icon}></i>
                            </Nav.Link>
                        </OverlayTrigger>
                    </Nav.Item>
                );
                })}

                {/* Help center overlay */}
                <Overlay
                    show={showHelp}
                    placement="bottom-end"
                    rootClose={true}
                    onHide={() => setShowHelp(false)}
                    target={targetHelp}
                >
                <Popover className={styles.navPopover}>
                    <Popover.Body>
                        <Container fluid className="gx-0">
                            <Row className="mb-1">
                                <Col className="col-12">
                                    <h3>Help & Support</h3>
                                </Col>
                            </Row>

                            {!isCollege && (
                            <Row
                                className="mb-2 ldd_pointer"
                                onClick={() =>
                                window.open(
                                    "https://lawyerdonedeal.zohodesk.com/portal/en/kb/ldd"
                                    + (isPageInDR(page) ? '/webdocumentretrieval' : '')
                                )
                                }
                            >
                                <Col className="col-1">
                                <i className="fa-solid fa-book"></i>
                                </Col>
                                <Col className="col-11">
                                <span>Knowledge Base</span>
                                </Col>
                            </Row>
                            )}

                            {sessionInfo && (
                            <>
                                {(!isCollege && appcode !== 'WILL') && (
                                <Row
                                    className="mb-2 ldd_pointer"
                                    onClick={() =>
                                    launchLDDnxt(
                                        "https://www.ldd.ca/book-training-rw",
                                        sid,
                                        sessionInfo
                                    )
                                }
                            >
                                <Col className="col-1">
                                <i className="fa-solid fa-calendar-circle-plus"></i>
                                </Col>
                                <Col className="col-11">
                                <span>Book Training</span>
                                </Col>
                            </Row>
                            )}

                            <Row className="mb-2 ldd_pointer" onClick={handleErrorClick}>
                            <Col className="col-1">
                                <i className="fa-solid fa-bug"></i>
                            </Col>
                            <Col className="col-11">
                                <span>Report an Error</span>
                            </Col>
                            </Row>

                            <Row
                            className="mb-2 ldd_pointer"
                            onClick={handleSuggestionClick}
                            >
                            <Col className="col-1">
                                <i className="fa-solid fa-mailbox-flag-up"></i>
                            </Col>
                            <Col className="col-11">
                                <span>Suggestion Box</span>
                            </Col>
                            </Row>

                            {(!isPageInDR(page)) && (
                                <Row
                                    className="mb-2 ldd_pointer"
                                    onClick={() =>
                                        launchLDDnxt(
                                        "https://www.ldd.ca/account-setup-letterhead-request",
                                        sid,
                                        sessionInfo
                                        )
                                    }
                                >
                                    <Col className="col-1">
                                        <i className="fa-solid fa-file-pen"></i>
                                    </Col>
                                    <Col className="col-11">
                                        <span>Letterhead Customization</span>
                                    </Col>
                                </Row>
                            )}

                            {(!isPageInDR(page) && appcode !== 'WILL') && (
                                <Row
                                    className="mb-2 ldd_pointer"
                                    onClick={() =>
                                        launchLDDnxt(
                                        "https://www.ldd.ca/account-setup-document-customization-request",
                                        sid,
                                        sessionInfo
                                        )
                                    }
                                >
                                    <Col className="col-1">
                                        <i className="fa-solid fa-file-pen"></i>
                                    </Col>
                                    <Col className="col-11">
                                        <span>Document Customization</span>
                                    </Col>
                                </Row>
                            )}
                            {(!isPageInDR(page) && appcode === 'WILL') && (
                                <Row
                                    className="mb-2 ldd_pointer"
                                    onClick={() =>
                                        launchLDDnxt(
                                        "https://zfrmz.com/Q8ijlFs06KWITx7wvtxY",
                                        sid,
                                        sessionInfo
                                        )
                                    }
                                >
                                    <Col className="col-1">
                                        <i className="fa-solid fa-file-pen"></i>
                                    </Col>
                                    <Col className="col-11">
                                        <span>Document Customization</span>
                                    </Col>
                                </Row>
                            )}
                            </>
                            )}

                            <hr />

                            <Row>
                                <Col className="col-1">
                                    <i className="fa-solid fa-phone fa-indicator"></i>
                                </Col>
                                <Col className="col-5">
                                    <b>1-800-363-2253</b>
                                </Col>
                                <Col className="col-1">
                                    <i className="fa-solid fa-envelope fa-indicator"></i>
                                </Col>
                                <Col className="col-5">
                                    <b>support@ldd.ca</b>
                                </Col>
                            </Row>
                        </Container>
                    </Popover.Body>
                </Popover>
            </Overlay>

                        {showErrorModal && <ReportForm showModal={showErrorModal} handleShowModal={() => setShowErrorModal(false)} handleSubmitResponse={formSubmitSuccessAlert} SESSION_INFO={sessionInfo} />}
                        {showSuggestionBox && <SuggestionForm showModal={showSuggestionBox} handleShowModal={() => setShowSuggestionBox(false)} handleSubmitResponse={formSubmitSuccessAlert} SESSION_INFO={sessionInfo} />}

                        {/* Account Icon and Popover */}
                        <OverlayTrigger placement="bottom" delay={200} overlay={
                            <Tooltip>{props.topBarConfig.account.tooltip}</Tooltip>
                        }>
                            <Nav.Item className={styles.item} ref={refAccount} onClick={(e:any) => handleAccountClick(e)}>
                                <Avatar initials={GetInitials(sessionInfo)} size="lg" />
                            </Nav.Item>
                        </OverlayTrigger>

                        <Overlay
                            show={showAccount}
                            placement="bottom-end"
                            rootClose={true}
                            onHide={() => setShowAccount(false)}
                            target={targetAccount}
                        >
                            <Popover ref={profileRef} className={styles.navPopover}>
                                <Popover.Body>
                                    <Container fluid className="gx-0">
                                    {sessionInfo && (
                                        <>
                                        <Row className="mb-2">
                                            <Col className='col-2 align-top'>
                                                <Avatar initials={GetInitials(sessionInfo)} size="lg" />
                                            </Col>
                                            <Col className='col-10'>
                                                <b>{GetFullName(sessionInfo)}</b>
                                                <Form.Label>{sessionInfo?.firm?.account || sessionInfo?.user?.fullname}</Form.Label>
                                            </Col>
                                        </Row>
                                    </>
                                    )}
                                        
                                    {props.topBarConfig.account.popoverItems.map((item, index) => {
                                    // Skip rendering if item requires session but sessionInfo is empty
                                    if (item.requireSession && !sessionInfo) return null;
                                    return (
                                        <Row key={index} className={`gx-1 ${item.type === 'switch' ? '' : styles.userMenuItem}`} onClick={item.action > "" ? actions[item.action] : null}>
                                            <Col className='col-1'>
                                                <i className={item.icon}></i>
                                            </Col>
                                            <Col className={item.type === 'switch' ? 'col-7' : 'col-11'}>
                                                <span>{item.label}</span>
                                            </Col>
                                            {item.type === 'switch' && (
                                                <Col className='col-4 align-right'>
                                                    <Form.Check
                                                        type="switch"
                                                        id={item.switchProps.id}
                                                        aria-label={item.switchProps.ariaLabel}
                                                        onChange={(e) => actions[item.switchProps.action](e)}
                                                        defaultChecked={(item?.switchProps?.defaultChecked)? actions[item.switchProps.defaultChecked](): false}
                                                    />
                                                </Col>
                                            )}
                                        </Row>
                                    );
                                })}

                                {!props.isEsignTopbar && <Row>
                                    <Col className="col-12">
                                        <hr />
                                    </Col>
                                </Row>}

                                {!props.isEsignTopbar && <Row>
                                    <Col className="col-12">
                                        <Button variant="primary" onClick={actions["logout"]}>
                                        <i
                                            className="fa-regular fa-right-from-bracket"
                                            style={{ marginRight: "5px" }}
                                        ></i>
                                        Log Out
                                        </Button>
                                    </Col>
                                </Row>}
                            </Container>
                        </Popover.Body>
                    </Popover>
                </Overlay>
            </Navbar.Collapse>
        </Col>
    </Navbar>
  );
};

export default BaseTopBar;
